import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";

import { CRMListObjectsType } from "../sub-modules/management/types";

export const getCrmName = (crm: CrmIntegrationProvider) => {
    return { salesforce: "Salesforce", hubspot: "HubSpot", dynamics: "Dynamics 365" }[crm];
};

export const getCrmListObjectsTypes = (crm: CrmIntegrationProvider): CRMListObjectsType[] => {
    return (
        {
            salesforce: [CRMListObjectsType.Accounts, CRMListObjectsType.Leads, CRMListObjectsType.AccountsAndLeads],
            hubspot: [CRMListObjectsType.Accounts, CRMListObjectsType.Contacts, CRMListObjectsType.AccountsAndContacts],
            dynamics: [CRMListObjectsType.Accounts, CRMListObjectsType.Leads, CRMListObjectsType.AccountsAndLeads],
        } as Record<CrmIntegrationProvider, CRMListObjectsType[]>
    )[crm];
};
